// Conforms to pending cart product or reservation product
interface Countable {
  count: number;
}

export const totalCount = (items: Countable[] = []) =>
  items.reduce((acc: number, { count }) => acc + count, 0);
